import React, { Component } from 'react';
import './App.css';

import Core from './core/Core'

class App extends Component {
  render() {
    return (
      <div className="App">
        <Core/>
      </div>
    );
  }
}

export default App;
